import React, { useMemo } from 'react';
import classnames from 'classnames';
import { SelectMultiple } from 'tea-component';
import { getPlaceholder, getSelectPanelHeight } from '@gp/utils/select';
import { defaultOptionTextRenderer } from '@gp/components/Select/utils/renderers';
import { renderButton } from './utils/renderers';
import { ALL_OPTION, GROUPS } from '@gp/constants/select';

import './index.scss';

const GPBaseSelectMultiple: React.FC<IGPBaseSelectMultipleProps> = (props) => {
  const {
    className,
    overlayClassName,
    boxClassName,
    showLabel = true,
    label = 'Metrics : ',
    placeholder: placeholderProps,
    appearance = 'button',
    matchButtonWidth: matchButtonWidthProps = true,
    listWidth,
    listHeight: listHeightProps,
    virtual: virtualProps,
    staging = false,
    searchable,
    allOption = ALL_OPTION,
    groups = GROUPS,
    button: buttonProps,
    optionTextRenderer = defaultOptionTextRenderer,
    options,
    renderOption,
    value,
    isNeedDiff = false,
    isFilter = false,
    showPlaceholder = false,
    ...restProps
  } = props;
  const placeholder = placeholderProps ?? getPlaceholder('selectMultiple', label);
  const listHeight = getSelectPanelHeight(searchable, listHeightProps);

  const button = renderButton(buttonProps, {
    allOption,
    options,
    value,
    showLabel,
    placeholder,
    showPlaceholder,
    label,
    optionTextRenderer,
  });

  const diffClassName = useMemo(() => {
    const optionsValues = options?.map((item: any) => item.value) || [];
    const valueTemp = value || [];
    const diffClassNameValue = new Set([...optionsValues, ...valueTemp]).size === valueTemp?.length;
    if (!diffClassNameValue && isNeedDiff) {
      return 'dbg-diff-filter-value';
    }
    return '';
  }, [options, value, isNeedDiff]);

  const matchButtonWidthCur = useMemo(() => {
    if (isFilter === true) return false;
    const matchButtonWidth = listWidth ? false : matchButtonWidthProps;
    return !options?.length ? true : matchButtonWidth;
  }, [matchButtonWidthProps, listWidth, isFilter, options]);

  return (
    <SelectMultiple
      {...restProps}
      className={classnames('dbg-common-select-multiple', className, diffClassName)}
      overlayClassName={classnames(
        'dbg-common-select-multiple-overlay globalpedia-custom-scrollbar',
        overlayClassName,
        {
          'dbg-common-select-multiple-overlay--empty': !options?.length,
          'dbg-common-select-multiple-overlay--all-option': !!allOption,
        },
      )}
      boxClassName={classnames('dbg-common-select-multiple-box', boxClassName)}
      placeholder={placeholder}
      appearance={appearance}
      matchButtonWidth={matchButtonWidthCur}
      listWidth={listWidth}
      listHeight={listHeight}
      // 无数据时启用虚拟滚动，确保上一次下拉项太多导致刷新下拉项异常
      virtual={virtualProps ?? !options?.length}
      staging={staging}
      searchable={searchable}
      allOption={allOption}
      groups={groups}
      button={button}
      options={renderOption ? renderOption : options || []}
      value={value}
    />
  );
};

export default GPBaseSelectMultiple;
